/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { MockPublicResolver } from "../MockPublicResolver";

export class MockPublicResolver__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<MockPublicResolver> {
    return super.deploy(overrides || {}) as Promise<MockPublicResolver>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): MockPublicResolver {
    return super.attach(address) as MockPublicResolver;
  }
  connect(signer: Signer): MockPublicResolver__factory {
    return super.connect(signer) as MockPublicResolver__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockPublicResolver {
    return new Contract(address, _abi, signerOrProvider) as MockPublicResolver;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "addr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "address_",
        type: "address",
      },
    ],
    name: "setAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b50610146806100206000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c80633b3b57de1461003b578063d5fa2b0014610080575b600080fd5b6100646100493660046100be565b6000908152602081905260409020546001600160a01b031690565b6040516001600160a01b03909116815260200160405180910390f35b6100bc61008e3660046100d6565b60009182526020829052604090912080546001600160a01b0319166001600160a01b03909216919091179055565b005b6000602082840312156100cf578081fd5b5035919050565b600080604083850312156100e8578081fd5b8235915060208301356001600160a01b0381168114610105578182fd5b80915050925092905056fea264697066735822122063a9897ba9e871efb6a002963750dfce86794ef7823ed1ded83d7d904b08618a64736f6c63430008040033";
